<template>
  <div :class="$style.wrapper">
    <BaseLabel v-if="label && !isLabelHidden">
      {{ label }}
    </BaseLabel>
    <input
      v-model.trim="inputValue"
      :class="[
        $style.input,
        isCentered && $style.isCentered,
        ...className
      ]"
      :type="type"
      :placeholder="placeholder"
      v-bind="$attrs"
      @focus="$emit('focus')"
    >
    <div
      v-if="!isErrorsHidden"
      :class="$style.errors"
    >
      <template v-if="form && form.$dirty">
        <span v-if="form.required === false">{{ $t('validation.required', {field: label}) }}</span>
        <span v-if="form.email === false">{{ $t('validation.email', {field: label}) }}</span>
        <span v-if="form.minLength === false">{{ $t('validation.min-length', {field: label, letters: form.$params.minLength.min}) }}</span>
        <span v-if="form.maxLength === false">{{ $t('validation.max-length', {field: label, letters: form.$params.maxLength.max}) }}</span>
        <span v-if="form.sameAsPassword === false">{{ $t('validation.same-as', {field: label, field2: $t(form.$params.sameAsPassword.eq)}) }}</span>
        <span v-if="form.chinaPhoneNumber === false">{{ $t('validation.china-phone-number', {field: label}) }}</span>
        <span v-if="form.isLowerCase === false">{{ $t('validation.is-lower-case', {field: label}) }}</span>
        <span v-if="form.alphaNum === false">{{ $t('validation.alpha-numeric', {field: label}) }}</span>
      </template>
    </div>
  </div>
</template>

<script>
import BaseLabel from '@/components/Atoms/Form/BaseLabel'
export default {
  name: 'BaseInput',
  components: { BaseLabel },
  inheritAttrs: false,
  props: {
    isLabelHidden: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: false,
      default: null,
    },
    form: {
      type: Object,
      require: true,
      default: () => {},
    },
    value: {
      type: [String, Number],
      required: false,
      default: '',
    },
    type: {
      type: String,
      required: false,
      default: 'text',
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    isCentered: {
      type: Boolean,
      required: false,
      default: false,
    },
    isErrorsHidden: {
      type: Boolean,
      required: false,
      default: false,
    },
    className: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      inputValue: this.value,
    }
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.inputValue = newValue
      }
    },
    inputValue(newValue) {
      this.$emit('input', newValue)
    },
  },
}
</script>

<style lang="scss" module>
  @import "../../../assets/scss/variables";
  .wrapper {
    padding: .5rem 0;
    .input {
      outline: none !important;
      background: none;
      border: none;
      width: 100%;
      font-size: $font-size-input;
      border-bottom: 1px solid $color-windswept-beach;
      color: $color-carbon;
      padding: .25rem .25rem;
      transition: background-color 5000s ease-in-out 0s;
    }
    .isCentered {
      text-align: center;
    }
    .errors {
      font-size: $font-size-tiny;
      padding: 0 .25rem;
      color: $color-tomato;
      height: 14px;
    }
  }
</style>
